$(document).ready(function () {
    'use strict';
    
    //send smart subscription link
    $('#subscription_login_link').submit(function (e) {
        e.preventDefault();
        const data = $(this).serialize();
        $.ajax({
            type: 'POST',
            url: baseURL + '/send-smart-link-mail',
            data: data,
            dataType: 'json',
            beforeSend: function () {
                screenLock();
            },
            success: function (results) {
                console.log(results);
                if (results.status === true) {
                    successMessagePopup(results.message);
                } else {
                    errorMessagePopup(results.message);
                }
            },
            complete: function () {
                screenUnLock();
            },
            error: function (response) {
                errorMessagePopup(response.responseJSON.message);
            },
        });
    });

});
